import { useCallback } from "react";

import { apiRequest } from "../services/main_api"
import { useNavigate } from "react-router-dom";

// utils 
import { showToast } from "../utils/toast";

// types 
import { HttpMethod } from "../types/global";


export type apiRequestHookOpts = {
    api: string;
    method?: HttpMethod;
    data?: Record<string, any>;
    onSuccess?: (response: any) => void;
    onFinal?: () => void;
    onError?: () => void;
};

export default function useApiRequestHook() {
    const navigate = useNavigate();

    const handleApiRequestHook = useCallback(
        async ({
            api,
            method = "GET",
            data,
            onSuccess,
            onFinal,
            onError,
        }: apiRequestHookOpts): Promise<void> => {
            if (!api) {
                showToast("API (URL) is required", "info");
                return;
            }
            try {
                const API = api;
                const response = await apiRequest({ API, DATA: data, METHOD: method });

                if (response?.success) {
                    if (!method.includes("GET")) {
                        showToast(response?.message || "Data get successfully", "success");
                    }
                    if (typeof onSuccess === "function") onSuccess(response);
                } else {
                    throw response;
                }
            } catch (error: any) {
                onError?.();
                if (typeof error === "object" && error?.status === 401) {
                    showToast(`${error?.message  || "Session expired. Please login again"}`, "error");
                    navigate("/login", { replace: true });
                    return;
                }

                if (error instanceof Error && error.message.toLowerCase().includes("login")) {
                    navigate("/login", { replace: true });
                    showToast(error.message, "error");
                    return;
                }

                let message = "Something went wrong";

                if (error instanceof Error) {
                    message = error.message;
                } else if (
                    typeof error === "object" &&
                    error !== null &&
                    "message" in error
                ) {
                    message = String((error as any).message);
                }

                console.error("Api returned error:", error);
                showToast(message, "error");
            } finally {
                if (typeof onFinal === "function") onFinal();
            }
        },
        []
    );

    return { handleApiRequestHook } as const;
}